/**
 * Format number with comma separators for thousands
 * @param {number|string} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number with commas
 */
export const formatCurrency = (value, decimals = 2) => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0.00';
  
  return num.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * Format number as MMK currency with symbol
 * @param {number|string} value - The number to format
 * @returns {string} Formatted currency string
 */
export const formatMMK = (value) => `${formatCurrency(value)} MMK`;

export const fmtTime = (d) =>
  new Date(d).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });

export const fmtDate = (d) =>
  new Date(d).toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });

export const fmtDateLong = (d) =>
  new Date(d).toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" });
